import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  Container,
  Typography,
  List,
  ListItem,
  Chip,
} from '@mui/material';

function Experience() {
  const { t } = useTranslation();

  const experiences = [
    { key: 'neoxam', current: true },
    { key: 'miage', current: false },
    { key: 'carteblanche', current: false },
  ];

  return (
    <Box
      id="experience"
      component="section"
      sx={{
        py: { xs: 6, md: 10 },
        position: 'relative',
        overflowX: 'hidden',
        width: '100%',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'linear-gradient(135deg, rgba(10, 10, 10, 0.8) 0%, rgba(10, 10, 10, 0.75) 100%)',
          backdropFilter: 'blur(20px)',
          zIndex: 0,
        },
      }}
    >
      <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>
        <Box sx={{ mb: { xs: 4, md: 6 } }}>
          <Typography
            variant="h2"
            sx={{
              fontSize: { xs: '2rem', sm: '2.5rem', md: '3.5rem' },
              fontWeight: 500,
              mb: 1.5,
              color: '#ffffff',
              fontFamily: '"Excellence In Motion", sans-serif',
            }}
          >
            {t('experience.title')}
          </Typography>
        </Box>

        {experiences.map((exp, index) => (
          <Box
            key={exp.key}
            sx={{
              mb: index < experiences.length - 1 ? { xs: 4, md: 8 } : 0,
              pb: index < experiences.length - 1 ? { xs: 3, md: 6 } : 0,
              borderBottom: index < experiences.length - 1 ? '1px solid #262626' : 'none',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'flex-start',
                mb: 2,
                flexDirection: { xs: 'column', sm: 'row' },
                gap: 2,
              }}
            >
              <Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 1 }}>
                  <Typography
                    variant="h5"
                    sx={{
                      fontWeight: 700,
                      fontSize: { xs: '1.5rem', md: '1.75rem' },
                      color: '#ffffff',
                    }}
                  >
                    {t(`experience.${exp.key}.company`)}
                  </Typography>
                  {exp.current && (
                    <Chip
                      label={t('experience.current')}
                      size="small"
                      sx={{
                        backgroundColor: 'rgba(255, 107, 107, 0.15)',
                        color: '#ff6b6b',
                        border: '1px solid rgba(255, 107, 107, 0.3)',
                        fontWeight: 600,
                      }}
                    />
                  )}
                </Box>
                <Typography
                  variant="body1"
                  sx={{
                    color: '#d4d4d4',
                    fontSize: '1.0625rem',
                    fontWeight: 500,
                  }}
                >
                  {t(`experience.${exp.key}.role`)}
                </Typography>
              </Box>

              <Typography
                variant="body2"
                sx={{
                  color: 'text.secondary',
                  fontSize: '0.875rem',
                  whiteSpace: 'nowrap',
                }}
              >
                {t(`experience.${exp.key}.period`)}
              </Typography>
            </Box>

            <List sx={{ p: 0, mt: 3 }}>
              {t(`experience.${exp.key}.tasks`, { returnObjects: true }).map((task, taskIndex) => (
                <ListItem
                  key={taskIndex}
                  sx={{
                    px: 0,
                    py: 1,
                    alignItems: 'flex-start',
                    display: 'block',
                  }}
                >
                  <Typography
                    variant="body2"
                    sx={{
                      color: '#d4d4d4',
                      lineHeight: 1.9,
                      fontSize: '1rem',
                      pl: 3,
                      position: 'relative',
                      fontWeight: 400,
                      '&:before': {
                        content: '""',
                        position: 'absolute',
                        left: 0,
                        top: '12px',
                        width: '8px',
                        height: '8px',
                        backgroundColor: '#ef4444',
                        borderRadius: '50%',
                      },
                    }}
                  >
                    {task}
                  </Typography>
                </ListItem>
              ))}
            </List>
          </Box>
        ))}
      </Container>
    </Box>
  );
}

export default Experience;
